/* eslint-disable max-len */

export const fr = {
  translation: {
    'app-subscription-4-7d-trial-per-day': {
      unlimitedReadings: {
        title: "Accédez aux guides d'astrologie et aux lectures de compatibilité illimités",
        contains: {
          affirmations: 'affirmations personnelles pour tous les jours',
          moreInsights: "plus d'informations en moins de temps",
          learnVisually: 'apprendre visuellement',
          minutesToRead: 'minutes de lecture',
        },
        benefits: {
          unlimitedCompatibilityChecks: 'vérifier la compatibilité autant de fois que nécessaire',
          manyInsight:
            "des centaines d'informations pour vous aider à atteindre vos objectifs relationnels",
          dailyHoroscopes:
            'horoscope quotidien personnalisé et guides astrologiques sans publicité',
          autoRenewable: "plan d'un mois auto-renouvelable, résiliation à tout moment",
        },
        button: 'Ajouter un nombre illimité de lectures',
        skip: 'Ignorer cette offre et poursuivre la procédure',
        disclaimer:
          "Remarque: En plus de votre abonnement, votre compte sera débité {{price}} pour les compléments sélectionnés lorsque vous cliquez sur Ajouter des lectures illimitées. Les articles figurant sur cette page sont des abonnements {{period}}. À moins que vous ne l'annuliez dans votre profil avant la fin de la période en cours, vous acceptez que l'abonnement soit renouvelé automatiquement à la fin de chaque période. Si vous avez besoin d'aide pour résilier votre abonnement, consultez notre section ",
      },
      trialPaymentWithDiscount: {
        offer: 'RABAIS SECRET <bold>65% de réduction</bold> appliqué',
        title: "Vous bénéficiez d'une réduction secrète !",
        pay: 'Commencez votre essai de 7 jours',
        subtitle: 'Pas de pression. Annulez à tout moment.',
        specialCode: 'Rabais secret appliqué !',
        price: "Votre coût par 2 semaines après l'essai:",
        priceExperiment: "Votre coût par 30 jours après l'essai:",
        saveMoney: 'Vous économisez {{savedMoney}}',
        saveMoneyExperiment: 'Vous économisez {{savedMoney}}',
        total: "Total aujourd'hui :",
        description: `En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 jours, vous serez automatiquement facturé {{ discountPrice }} pour la période d'introduction de 2 semaines, puis au taux standard de {{ fullPrice }} tous les 2 semaines jusqu'à ce que vous annuliez dans les paramètres. Pour en savoir plus sur la politique d'annulation et de remboursement, voir`,
        descriptionExperiment: `En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 jours, vous serez automatiquement facturé {{ discountPrice }} pour la période d'introduction de 30 jours, puis au taux standard de {{ fullPrice }} tous les 30 jours jusqu'à ce que vous annuliez dans les paramètres. Pour en savoir plus sur la politique d'annulation et de remboursement, voir`,
        terms: 'Conditions de souscription',
      },
      salesScreen: {
        title: 'Votre clarté personnalisée & Love Reading est prêt!',
        fixedHeader: {
          title: `La remise expire`,
          minutes: 'min',
          seconds: 'sec',
          button: 'obtenir ma lecture',
        },
        userDetails: {
          youImageText: 'Vous',
          partnerImageText: 'Partenaire',
          zodiac: 'Signe du zodiaque',
          gender: 'Genre',
          dateOfBirth: 'Date de naissance',
          placeOfBirth: 'Lieu de naissance',
          female: 'Femme',
          male: 'Homme',
        },
        sectionGoal: {
          title: 'Le but à atteindre',
          'Find my perfect partner': 'Trouver le partenaire idéal',
          'Understand myself better': 'Mieux me comprendre',
          'To get married': 'Se marier',
          'Achieve happiness': 'Atteindre le bonheur',
          'Personal growth': 'Croissance personnelle',
          'Check compatibility': 'Vérifier la compatibilité',
          'Increase relationship satisfaction': 'Augmenter la satisfaction de votre relation',
          'Fix relationship problems': 'Résoudre les problèmes de relation',
          'Build a strong marriage': 'Construire un mariage solide',
          'All above': "Trouver l'amour et mieux me comprendre",
          'All above in relationships': 'Améliorer les relations',
        },
        specialOffer: {
          header: 'Offre spéciale',
          trialTitle: 'Lecture personnalisée pour ',
          total: "Total aujourd'hui :",
          discount: 'La remise expire',
          saveMoney: 'Economisez {{discount}} par période',
          perWeeksCostOld: "Votre coût par 30 jours <bold>après l'essai</bold>",
          perWeeksCost: "Y compris 1 semaine d'essai de lecture personnelle",
          optionTitle: 'Choisissez une option:',
          expensiveOption:
            "Soutenir ceux qui ont besoin de choisir le prix d'essai le plus bas en choisissant cette option",
          getAccess: 'obtenir ma lecture',
        },
        guaranteeText: 'Paiements de sécurité garantis',
        blurredReport: {
          title: 'Votre rapport',
          zodiac: 'Signe du zodiaque',
          gender: 'Genre',
          contentTitle: 'Contenu',
          points: [
            "Compatibilité avec votre partenaire dans d'autres domaines de votre vie.",
            'Une analyse approfondie des relations avec votre partenaire, basée sur un ' +
              'système unique de correspondance des cartes de naissance.',
            'Un guide simple et pratique pour améliorer votre relation avec votre partenaire.',
            'Avertissement sur les événements astrologiques et conseils pratiques qui vous ' +
              'aideront à bien traverser cette période.',
            'Votre horoscope et les événements à venir en 2023',
            'Vos forces et faiblesses uniques et comment en tirer le meilleur parti.',
          ],
          personalityTitle: 'Personnalité',
          personalityContent:
            "Le Verseau est le 11e signe du zodiaque et représente l'inventivité " +
            'et la brillance. Les planètes dominantes sont Uranus et Saturne, ce qui confère à ce ' +
            'signe une personnalité à la fois restreinte et libérée. Saturne est associé aux limites ' +
            "et aux frontières, tandis qu'Uranus est le symbole de la liberté.",
          accessDescription: 'Pour lire le rapport complet vous devez obtenir aceess',
          getAccess: 'obtenir ma lecture',
        },
        userReviews: {
          title: 'Les usagers nous aiment',
          list: {
            user1: {
              review:
                `Il m'a été très utile et m'a apporté la clarté dont j'avais besoin dans la ` +
                `situation actuelle de ma relation. Cela me donne l'espoir que ma relation peut ` +
                `encore être sauvée. Je vous remercie. Hautement recommandé !`,
            },
            user2: {
              review:
                "Incroyable, absolument incroyable ! Les affirmations que j'ai reçues et les conseils que " +
                "j'ai reçus valaient tout l'or du monde ! Vraiment, merci !",
            },
            user3: {
              review:
                "Il m'aide à avoir confiance en moi et en mes choix pour l'avenir en me rassurant " +
                'grâce aux informations que je reçois. Mes objectifs et mes rêves vont se réaliser ' +
                "et maintenant je me fais confiance pour faire ce dont j'ai besoin et ce que je souhaite.",
            },
          },
        },
        benefits: {
          title: 'Ce que vous obtenez',
          points: [
            'Votre plan personnalisé',
            '1:1 conseils de votre propre astrologue',
            'Trouver un partenaire compatible',
            'Des informations sur vos schémas relationnels et sur vos besoins émotionnels et sexuels',
            'Meilleure compréhension de soi',
          ],
        },
        featuredInTitle: 'Tel que présenté dans',
        QASection: {
          title: 'On demande souvent',
          question1: 'Quelle est la précision de la lecture astrologique sur cette plateforme ?',
          answer1:
            "L'exactitude d'une lecture astrologique, bien que subjective et inexacte, " +
            'peut offrir des éclairages utiles. Notre plateforme, combinant algorithmes ' +
            'avancés et astrologues experts, vise à maximiser cette précision.',
          question2: 'Puis-je obtenir une lecture de compatibilité pour les relations ?',
          answer2:
            "Oui, il est possible d'obtenir une lecture de compatibilité pour les relations. " +
            'Ce type de lecture comprend une analyse astrologique complète de deux personnes ' +
            "afin d'évaluer leur compatibilité dans divers domaines, notamment l'amour, la " +
            'communication et les valeurs partagées.',
          question3:
            'Les lectures astrologiques sur cette plateforme sont-elles confidentielles et privées ?',
          answer3:
            'Oui, toutes nos lectures sont strictement confidentielles. Nous préservons la ' +
            'confidentialité des utilisateurs, sécurisons leurs données et ne les partageons ' +
            'jamais sans consentement.',
        },
        charge: {
          trial:
            'Vous serez facturé seulement <bold>{{trialPrice}} pour votre essai de 7</bold> jours. ' +
            "Nous vous enverrons un rappel par <bold>e-mail</bold> avant la fin de votre période d'essai. " +
            '<bold>Annulez à tout moment.</bold>',
          europeanTrial:
            'Vous serez facturé seulement <bold>{{europeanTrialPrice}} pour ' +
            'votre essai de 7</bold> jours. Nous vous enverrons un rappel par <bold>e-mail</bold> ' +
            "avant la fin de votre période d'essai. <bold>Annulez à tout moment.</bold>",
          trialUSStart: 'Vous souscrivez à un abonnement mensuel au service ',
          trialUSEnd:
            ". En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 jours pour le {{trialPrice}}, vous serez automatiquement facturé {{fullPrice}} tous les 2 semaines jusqu'à ce que vous annuliez dans les paramètres. Les frais apparaîtront sur votre facture sous le nom de {{domainUrl}}. Pour en savoir plus sur la politique d'annulation et de remboursement, consultez la section",
          trialUS:
            "Vous vous inscrivez à l'abonnement mensuel au service NEBULA. En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 jours pour le {{trialPrice}}, vous serez automatiquement facturé {{fullPrice}} tous les 30 jours jusqu'à ce que vous annuliez dans les paramètres. Les frais apparaîtront sur votre facture sous le nom de {{domainUrl}}. Pour en savoir plus sur la politique d'annulation et de remboursement, consultez la section ",
        },
        chargeTest:
          'Vous serez facturé seulement <bold>{{price}} pour ' +
          'votre essai de 7</bold> jours. Nous vous enverrons un rappel par <bold>e-mail</bold> ' +
          "avant la fin de votre période d'essai. <bold>Annulez à tout moment.</bold>",
        description: {
          text:
            'Vous souscrivez un abonnement de 2 semaines au NEBULA service. ' +
            "En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 " +
            'jours pour <bold>{{trialPrice}}</bold>, ' +
            'vous serez automatiquement facturé <bold>{{plan}}</bold> ' +
            "toutes les 2 semaines jusqu'à ce que vous annuliez dans les paramètres. " +
            "Pour en savoir plus sur la politique d'annulation et de remboursement, consultez la ",
          textEU:
            'Vous souscrivez un abonnement de 2 semaines au NEBULA service. ' +
            "En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 " +
            'jours pour <bold>{{europeanTrialPrice}}</bold>, ' +
            'vous serez automatiquement facturé <bold>{{plan}}</bold> ' +
            "toutes les 2 semaines jusqu'à ce que vous annuliez dans les paramètres. " +
            "Pour en savoir plus sur la politique d'annulation et de remboursement, consultez la ",
          terms: "Politique d'abonnement",
          termsEU: "Politique d'abonnement",
          termsExperiment: "consultez les conditions d'abonnement",
        },
        trialChoiceDescription: {
          header:
            'Nous avons aidé des millions de personnes à avoir une vie plus heureuse et de meilleures relations, et ' +
            'nous voulons vous aider aussi.',
          money:
            "L'argent ne devrait pas se mettre en travers de la recherche d'une guidance astrologique qui fonctionne " +
            'enfin. Alors, choisissez un montant que vous jugez raisonnable pour nous essayer pendant une semaine.',
          paymentDescription:
            'Il nous en coûte {{priceForUs}} pour offrir un essai de 7 jours, mais veuillez choisir le montant ' +
            "avec lequel vous êtes à l'aise.",
        },
      },
      payment: {
        title: 'Choisir la méthode de paiement',
        divider: 'ou',
        chargeDisclaimer: 'Vous ne serez facturé que',
        form: {
          default: {
            submitButtonText: 'DÉMARRER ESSAI DE 7 JOURS',
            charged: 'Vous ne serez facturé que {{price}} pour votre essai de 7 jours.',
          },
          resign: {
            submitButtonText: 'Acheter',
          },
        },
        charge: {
          trialWithoutPrice:
            "Nous vous <bold>enverrons un rappel par e-mail</bold> avant la fin de votre période d'essai. " +
            'Annuler à tout moment.',
          trial:
            'Vous ne serez facturé que de <bold>{{price}} pour votre essai de 7 jours.</bold><br/>' +
            "Nous vous <bold>enverrons un rappel par e-mail</bold> avant la fin de votre période d'essai. " +
            'Annuler à tout moment.',
          trialUS:
            "Vous ne serez facturé <bold>{{price}}} que pour votre période d'essai de 7 jours." +
            "Nous vous enverrons un email de rappel</bold> avant la fin de votre période d'essai. " +
            'Annulez à tout moment. Les frais apparaîtront sur votre facture sous le nom de {{domainUrl}}.',
          full: 'Vous ne serez facturé que <bold>{{price}} pour votre essai de 7 jours.</bold>',
          email:
            "Nous vous <bold>enverrons un rappel par e-mail</bold> avant la fin de votre période d'essai. " +
            '<bold>Annuler à tout moment.</bold>',
        },
        pay: {
          trial: 'Votre <bold>essai de 7 jours</bold>',
          price: 'Seulement',
          tax: 'TVA',
          total: 'Total',
        },
        resources: 'Paiements sécurisés',
      },
    },
    'natal-chart': {
      progressBar: 'Prenez le contrôle de votre vie',
      billingScreen: {
        description:
          "En continuant, vous acceptez d'être automatiquement facturé {{price}} chaque mois jusqu'à ce que vous annuliez dans les paramètres. Pour en savoir plus sur la politique d'annulation et de remboursement ",
        trialDescription:
          "Vous souscrivez à un <bold>abonnement de 7 jours</bold> au service NEBULA. En continuant, vous acceptez que si vous n'annulez pas avant la fin de la période d'essai de 7 jours pour {{trialPrice}}</bold>, vous serez automatiquement facturé {{price}} tous les mois jusqu'à ce que vous annuliez dans les paramètres. Pour en savoir plus sur la politique d'annulation et de remboursement",
        terms: "Conditions d'abonnement.",
      },
    },
    common: {
      aquarius: 'verseau',
      aries: 'bélier',
      cancer: 'cancer',
      capricorn: 'capricorne',
      gemini: 'gemeaux',
      leo: 'lion',
      libra: 'balance',
      pisces: 'poissons',
      sagitarius: 'sagittaire',
      scorpio: 'scorpion',
      taurus: 'taureau',
      virgo: 'vierge',
      male: 'homme',
      female: 'femelle',
    },
    agreement: {
      text: "En sélectionnant l'option ci-dessus, vous acceptez",
      policy: 'La politique de confidentialité',
      separator: 'et',
      terms: "Les conditions d'utilisation.",
      textEnd: '',
    },
    emailAgreement: {
      text: "En continuant, j'accepte",
      policy: 'la politique de confidentialité',
      separator: 'et',
      terms: "les conditions d'utilisation",
      textEnd: 'de Nebula.',
    },
    paymentFailed: {
      title: 'Paiement échoué',
      text: "Votre transaction a échoué en raison d'une erreur technique. Veuillez réessayer.",
      button: 'Réessayer',
    },
  },
};
